module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/e0d2c41f459e3cbc649c428dcefffcb6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_bolt.svg
// module id = vvfS
// module chunks = 0